import "@babel/polyfill";
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import VantUI, {Dialog, Toast} from 'vant'
import VueLoaders from 'vue-loaders';
import VueQuillEditor from 'vue-quill-editor'
import MyCodeMirror from "./component/MyCodemirror/index";
import VueAMap from 'vue-amap';
import * as dd from 'dingtalk-jsapi';
// import RyForm from 'ry-form'
import RyForm from './component/ry-component/index'
import wx from 'weixin-js-sdk'
import components from './component/index'
import VueTitle from 'vue-wechat-title'
import VueQriously from 'vue-qriously'

import './reset.css'
import 'quill/dist/quill.bubble.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'vant/lib/index.less'
import 'vant/lib/icon/local.css';
import './index.less'
import './RyDashBoard/redact/index.less'
import './RyHomeConfig/redact/index.less'
import element from './element/index'
import 'element-ui/lib/theme-chalk/index.css';
import MetaInfo from 'vue-meta-info'
import 'froala-editor/js/plugins.pkgd.min.js';
//Import third party plugins
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
// import 'froala-editor/js/third_party/spell_checker.min';
import 'froala-editor/js/third_party/image_tui.min';
import 'froala-editor/js/languages/zh_cn.js';
// Import Froala Editor css files.
import 'froala-editor/css/froala_editor.pkgd.min.css';
import "froala-editor/css/froala_style.min.css";
import FroalaEditor from 'froala-editor';
// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg'


import ECharts from 'echarts'
import 'echarts/map/js/china'
import 'echarts/map/js/province/guangdong'
import 'echarts/map/js/province/shanxi'
import 'echarts/map/js/province/shanxi1'
import 'echarts/map/js/province/anhui'
import 'echarts/map/js/province/aomen'
import 'echarts/map/js/province/beijing'
import 'echarts/map/js/province/chongqing'
import 'echarts/map/js/province/fujian'
import 'echarts/map/js/province/gansu'
import 'echarts/map/js/province/guangxi'
import 'echarts/map/js/province/guizhou'
import 'echarts/map/js/province/hainan'
import 'echarts/map/js/province/hebei'
import 'echarts/map/js/province/heilongjiang'
import 'echarts/map/js/province/henan'
import 'echarts/map/js/province/hubei'
import 'echarts/map/js/province/hunan'
import 'echarts/map/js/province/jiangsu'
import 'echarts/map/js/province/jiangxi'
import 'echarts/map/js/province/jilin'
import 'echarts/map/js/province/liaoning'
import 'echarts/map/js/province/neimenggu'
import 'echarts/map/js/province/ningxia'
import 'echarts/map/js/province/qinghai'
import 'echarts/map/js/province/shandong'
import 'echarts/map/js/province/shanghai'
import 'echarts/map/js/province/sichuan'
import 'echarts/map/js/province/taiwan'
import 'echarts/map/js/province/tianjin'
import 'echarts/map/js/province/xianggang'
import 'echarts/map/js/province/xinjiang'
import 'echarts/map/js/province/xizang'
import 'echarts/map/js/province/yunnan'
import 'echarts/map/js/province/zhejiang'


Vue.prototype.$ECharts = ECharts



Vue.use(MetaInfo)

// 飞书jssdk --> document.write("<script src='//s3.bytecdn.cn/ee/lark/js_sdk/h5-js-sdk-1.4.12.js'><\/script>");

// const BrowserLogger = require('alife-logger');
// if (process.env.NODE_ENV === 'production') {
//   const __bl = BrowserLogger.singleton({
//     pid: "c0snrif71w@bd6756f84d6117d",
//     appType: "web",
//     imgUrl: "https://arms-retcode.aliyuncs.com/r.png?",
//     sendResource: true,
//     enableLinkTrace: true,
//     behavior: false,
//     enableSPA: true,
//     useFmp: true
//   });
// }

Vue.use(VueQriously)
Vue.use(VueTitle)
Vue.use(RyForm)
Vue.use(VueQuillEditor)
Vue.use(components)
Vue.use(MyCodeMirror)


Vue.use(element)

Vue.prototype.$RyFs.getToken = ({files, companyId}) => store.dispatch('actionGetFileToken', {files, companyId})
Vue.prototype.$RySocket.getAccount = () => store.dispatch('actionGetAccount')
Vue.prototype.$RySocket.getUrl = () => store.dispatch('mqttGet')

// 绑定第三方账号成功消息通知
Vue.prototype.$RySocket.MESSAGE_TYPE_THIRD_BIND_SUC = 1002
// 绑定第三方账号失败消息通知
Vue.prototype.$RySocket.MESSAGE_TYPE_THIRD_BIND_FAIL = 1003
// 更新看板视图数据消息通知
Vue.prototype.$RySocket.MESSAGE_TYPE_UPDATE_BOARD_VIEW = 1005
Vue.prototype.$RySocket.MESSAGE_TYPE_REFRESH_DATA = 1200 // 刷新数据消息
Vue.prototype.$RySocket.MESSAGE_TYPE_PLUGIN_RESULT = 1300 // 插件执行结果消息
Vue.prototype.$RySocket.MESSAGE_TYPE_UPDATE_FORM = 1400 // 更新表单数据消息

Vue.prototype.$BASE_PATH = '/apaas/form'
Vue.prototype.$MINIAPP_BASE_PATH = '/apaas/miniapp'
Vue.prototype.$FORWARD_BASE_PATH = '/apaas/forwardjs'
Vue.prototype.$DS_BASE_PATH = '/apaas/miniappds'

console.log('ua--', window.ua);
if (window.isWxWork) {
    console.log('wxwork---', window.wx)
    Vue.prototype.$wx = window.wx // index.html中引入外部js，获取js暴露的wx
} else if (window.isLark) {
    console.log('isLark---', window.tt, window.h5sdk)
    Vue.prototype.$tt = window.h5sdk // index.html中引入外部js，获取js暴露的wx
}else if (window.isDingtalk) {
    console.log('isDingtalk---', dd)
    Vue.prototype.$dd = dd // index.html中引入外部js，获取js暴露的wx
} else {
    console.log('wx---', wx)
    Vue.prototype.$wx = wx
}

Toast.allowMultiple();

Vue.use(VantUI);
Vue.use(Dialog);
Vue.use(VueLoaders);
Vue.config.productionTip = false;
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
    key: 'd6f1c613c6f0c9897333333333',
    plugin: ['AMap.Geolocation', 'AMap.Marker', 'AMap.ToolBar', 'AMap.Circle', 'AMap.PolyLine', 'AMap.GraspRoad', 'AMap.InfoWindow', 'AMap.Geocoder'],
    uiVersion: '1.1.1', // 版本号
    // 默认高德 sdk 版本为 1.4.4
    v: '1.4.15'
});

Vue.prototype.$FroalaEditor = FroalaEditor
Vue.use(VueFroala)

const vue = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');

export default vue
